import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createBaseSelector, registerSlice } from "shared/lib/redux";
import { RoadSearchCardModel } from "./model";

type RoadSearchCard = RoadSearchCardModel[];

const initialAppState: RoadSearchCard = [];

const roadSearchCardSlice = createSlice({
  name: "roadSearchCards",
  initialState: initialAppState,
  reducers: {
    prependSearchCardAction: (
      state,
      { payload: { data, unique = true } }: PayloadAction<{ data: RoadSearchCardModel; unique?: boolean }>
    ) => {
      if (unique) {
        const foundCard = state.find((card) => card.reference === data.reference);
        if (foundCard) return;
      }
      state.unshift(data);
    },
    removeSearchCardAction: (state, action: PayloadAction<RoadSearchCardModel>) => {
      return state.filter((card) => card.reference !== action.payload.reference);
    },
    updateSearchCardAction: (state, action: PayloadAction<RoadSearchCardModel>) => {
      const targetCard = state.findIndex((card) => card.reference === action.payload.reference);
      if (targetCard !== -1) {
        state[targetCard] = action.payload;
      }
    },
  },
});

const roadSearchCardBaseSelector = createBaseSelector(roadSearchCardSlice);

registerSlice([roadSearchCardSlice]);

export const roadSearchCardStore = {
  actions: roadSearchCardSlice.actions,
  selectors: {
    searchCards: createSelector(roadSearchCardBaseSelector, (s) => s),
  },
};
